import {
  Alert,
  Table,
  TableBody,
  TableCell,
  TableHead,
  Typography,
} from '@mui/material';
import { LoadingSpinner } from '../../core/LoadingSpinner';
import {
  useGetAllTimeRecords,
  useGetTimeRecordBreaks,
} from '../../hooks/reactQuerys/TimeRecordQueries';
import { useGetUsers } from '../../hooks/reactQuerys/UserQueries';
import { TimeRecordEmployeeRow } from './TimeRecordEmployeeRow';

export const TimeRecordOverview = () => {
  const { users, isLoadingUsers } = useGetUsers();
  const { allTimeRecords, isLoadingAllTimeRecords } = useGetAllTimeRecords();
  const { timeRecordBreaks, isLoadingTimeRecordBreaks } =
    useGetTimeRecordBreaks();

  if (isLoadingUsers || isLoadingAllTimeRecords || isLoadingTimeRecordBreaks) {
    return <LoadingSpinner />;
  }

  if (!users || !allTimeRecords || !timeRecordBreaks) {
    return <Alert severity='error'>Fehler!</Alert>;
  }

  return (
    <>
      <Typography variant='h5'>Zeiterfassung</Typography>

      <Table>
        <TableHead>
          <TableCell>Mitarbeiter</TableCell>
          <TableCell>Heute</TableCell>
          <TableCell>Woche</TableCell>
          <TableCell>Monat</TableCell>
          <TableCell>Jahr</TableCell>
          <TableCell>Aktionen</TableCell>
        </TableHead>

        <TableBody>
          {users.map(user => (
            <TimeRecordEmployeeRow
              key={`timerecord-idUser-${user.idUser}`}
              currentUser={user}
              timeRecordArray={allTimeRecords}
              timeRecordBreakArray={timeRecordBreaks}
            />
          ))}
        </TableBody>
      </Table>
    </>
  );
};
